import type { DocumentRevision } from '@/entities/Document';
import { createDocumentRevisionsStore } from '@/entities/Document';

export const store = createDocumentRevisionsStore<DocumentRevision>('documentRevisions');
